import PageLoadedQueue from "../PageLoadedQueue";

class Dashboard {

    protected menuTriggerElement: HTMLElement;
    protected navElement: HTMLElement;
    protected dashboardElement: HTMLElement;

    constructor(dashboardElement: HTMLElement) {
        this.dashboardElement = dashboardElement;
        this.menuTriggerElement = dashboardElement.querySelector('.plandent-dashboard__nav__trigger');
        this.navElement = dashboardElement.querySelector('.plandent-dashboard__nav');

        this.initializeListeners();
    }

    protected initializeListeners = () => {

        if (this.menuTriggerElement) {
            this.menuTriggerElement.addEventListener('click', (e) => {
                this.navElement.classList.toggle('toggled');
            });
        }
    }

    static initialize() {
        const dashboardElement: HTMLElement = document.querySelector('.plandent-dashboard');
        if (dashboardElement) {
            new Dashboard(dashboardElement);
        }
    }
}

PageLoadedQueue.addFunction(Dashboard.initialize);
